export const getEnvironmentVariable = (variableName: string, fallback?: string): string => {
  const value = import.meta.env[variableName as keyof ImportMetaEnv] as string | undefined;

  if (value !== undefined && value !== null && value !== "") {
    return value;
  }

  if (fallback !== undefined) {
    return fallback;
  }

  throw new Error(`Missing environment variable: ${variableName}`);
};